import { supabase } from './supabase'

/**
 * Fetch all API keys for a company (key_hash is never returned)
 */
export async function getApiKeys(companyId) {
  const { data, error } = await supabase
    .from('api_keys')
    .select(
      'id, name, key_prefix, permissions, is_active, revoked_at, revoked_by, expires_at, last_used_at, request_count, rate_limit_per_minute, created_date, created_by'
    )
    .eq('company_id', companyId)
    .order('created_date', { ascending: false })

  if (error) throw error
  return data
}

/**
 * Create a new API key via RPC (returns the full key exactly once)
 */
export async function createApiKey(companyId, { name, permissions, expiresAt, rateLimit }) {
  const { data, error } = await supabase.rpc('create_api_key', {
    p_company_id: companyId,
    p_name: name,
    p_permissions: permissions,
    p_expires_at: expiresAt || null,
    p_rate_limit: rateLimit || 60,
  })

  if (error) throw error
  return data?.[0] // { id, key_prefix, full_key }
}

/**
 * Revoke an API key (soft-delete: marks inactive with timestamp)
 */
export async function revokeApiKey(keyId, userId) {
  const { error } = await supabase
    .from('api_keys')
    .update({
      is_active: false,
      revoked_at: new Date().toISOString(),
      revoked_by: userId,
    })
    .eq('id', keyId)

  if (error) throw error
}

/**
 * Delete an API key permanently
 */
export async function deleteApiKey(keyId) {
  const { error } = await supabase
    .from('api_keys')
    .delete()
    .eq('id', keyId)

  if (error) throw error
}
